import { SxProps, Theme } from "@mui/material";
import { LOTTIE_SIZES, lottieFrameStyle } from "./lottieSizing";
import noDataAnimation from "../../lottie/no-data.json";

export const getLibraryEmptyStateAnimationSx = (
  animationData: object,
  marginBottom = 0.5,
): SxProps<Theme> => ({
  ...lottieFrameStyle(
    animationData === noDataAnimation
      ? LOTTIE_SIZES.searchEmptyState
      : LOTTIE_SIZES.emptyState,
  ),
  mb: marginBottom,
});
